<template lang="pug">
  v-btn(
    v-bind="extendAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import { VBtn } from 'vuetify/lib';

export default {
  components:  { VBtn },
  props: {
    text: {
      type: Boolean,
      default: false,
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      const { light, text, stacked } = this;
      return {
        text,
        light,
        color: 'ui-primary',
        ripple: false,
        ...text ? {
          minWidth: 'unset',
        } : {},
        ...text || stacked ? {
          height: 'unset',
        } : {},
        class: [
          'dv-btn',
          'ui-body-1',
          ...text ? ['px-0'] : [],
          ...light ? ['dv-btn--light'] : [],
        ],
        ...this.$attrs,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-btn {
  &:not(.dv-btn--light) {
    color: #{$ui-bright};
  }
  border-radius: 10px;
  &.v-btn--disabled {
    opacity: 0.6 !important;
  }
  &::before,
  &::after {
    content: '';
    display: none;
  }

  &.v-btn--disabled {
    &.v-btn--has-bg {
      background-color: #{$ui-neutral-lighten4} !important;
    }

    &:deep() {
      * {
        color: #{$ui-neutral-lighten1} !important;
      }
    }
  }
}
</style>
